import type { ReactNode } from 'react';

import styles from './data-builder-page-template.module.css';

type DataBuilderPageTemplateProps = {
  sidebar?: ReactNode;
  children: ReactNode;
};

export const DataBuilderPageTemplate = ({
  sidebar,
  children,
}: DataBuilderPageTemplateProps) => (
  <div className={styles.pageContainer}>
    <div className={styles.pageShell}>
      {sidebar !== undefined && sidebar !== null && (
        <div className={styles.sidebar}>{sidebar}</div>
      )}
      <main className={styles.contentArea}>
        <div className={styles.stepArea}>{children}</div>
      </main>
    </div>
  </div>
);
